module.exports = __webpack_public_path__ + "static/img/Boss_Two Color.4de506c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Boss_Two Color.png
// module id = CL4N
// module chunks = 1